import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  email: "",
  designation: "",
  header: false,
  name: "",
  avatar: "",
  role: "",
  isLoaded: false,
  error: null,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    login: (state, action) => {
      console.log(action.payload);
      state.email = action.payload.email;
      state.designation = action.payload.designation;
      state.header = action.payload.header;
      state.name = action.payload.name || "";
      state.avatar = action.payload.avatar || "";
      state.role = action.payload.role || "";
      state.isLoaded = true;
      state.error = null;
    },
    logout: (state) => {
      state.email = "";
      state.designation = "";
      state.header = false;
      state.name = "";
      state.avatar = "";
      state.role = "";
      state.isLoaded = false;
      state.error = null;
    },
    setLayout: (state, { payload }) => {
      state.layout = payload;
    },
    setToogleHeader: (state, { payload }) => {
      state.header = payload;
    },
    updateUserDetails: (state, { payload }) => {
      state.name = payload.name || state.name;
      state.avatar = payload.avatar || state.avatar;
      state.role = payload.role || state.role;
      state.designation = payload.designation || state.designation;
    },
    setError: (state, { payload }) => {
      state.error = payload;
    },
  },
});

export const {
  login,
  logout,
  setLayout,
  setToogleHeader,
  updateUserDetails,
  setError,
} = userSlice.actions;
export default userSlice.reducer;
